/** @jsx jsx */

import { css, jsx } from '@emotion/react';
var contentSlotStyles = css({
  minWidth: 0,
  // this spacing is a specific affordance to the avatar border
  paddingTop: "var(--ds-space-025, 2px)",
  gridArea: 'comment-area',
  wordWrap: 'break-word'
});
/**
 * __ContentSlot__
 *
 * The content slot is used to nest content in a comment's layout. It should be used inside a CommentLayout.
 *
 */
var ContentSlot = function ContentSlot(_ref) {
  var children = _ref.children;
  return jsx("div", {
    css: contentSlotStyles
  }, children);
};
export default ContentSlot;